import { createContext, useContext } from 'react';
import { useScreenSidebar } from './useScreenSidebar';
const Context = createContext({
    id: 'default',
    state: 'ready',
});
export const useScreenLayout = () => {
    const { id, state } = useContext(Context);
    const sidebar = useScreenSidebar(id);
    return {
        id,
        sidebar,
        state,
    };
};
export function ScreenLayoutProvider(props) {
    const { id, children, state } = props;
    const value = {
        id,
        state,
    };
    return <Context.Provider value={value}>{children}</Context.Provider>;
}
